var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.097631 11.7071 0.292893L15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289L12.5858 6L1 6C0.447716 6 4.17233e-07 5.55228 4.17233e-07 5C4.76837e-07 4.44771 0.447716 4 1 4L12.5858 4L10.2929 1.70711C9.90237 1.31658 9.90237 0.683417 10.2929 0.292893ZM5.70711 10.2929C6.09763 10.6834 6.09763 11.3166 5.70711 11.7071L3.41421 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H3.41421L5.70711 18.2929C6.09763 18.6834 6.09763 19.3166 5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071L0.292893 15.7071C0.105357 15.5196 0 15.2652 0 15C0 14.7348 0.105357 14.4804 0.292893 14.2929L4.29289 10.2929C4.68342 9.90237 5.31658 9.90237 5.70711 10.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsLight);
export default __webpack_public_path__ + "static/media/transactions-light.25e6577828626472a5fc0fe6e89aaa39.svg";
export { ForwardRef as ReactComponent };